module.exports = __webpack_public_path__ + "static/media/manufacturing.99b85251.jpg";